import React from 'react';
import { useTranslations } from '@lang';
import moment from 'moment';
import { NoAvailabilityStyled } from './NoAvailability.styles';

export const NoAvailability = ({ date, display }) => {
  const { t } = useTranslations();
  return display ? (
    <NoAvailabilityStyled data-cy="no-availability">
      {t('common.noAvailabilityOn')} {moment(date).format('ddd DD MMM')}
    </NoAvailabilityStyled>
  ) : null;
};
